































































































































































































































































































































import { Component } from "vue-property-decorator";
import BaseFormEdit from "../../models/base.form.edit";
import Certificate from "../../models/certificate";
import axios from "axios";
import FileUploader from "@/components/FileUploader.vue";
import Typeahead from "vue-typeahead-bootstrap";
var jsonp = require("jsonp");

@Component({
  components: {
    FileUploader,
    Typeahead,
  },
})
export default class Edit extends BaseFormEdit {
  public form: any = new Certificate();
  public urlPrefix = "pmdd";
  public files: any[] = [];
  public biomaterialSamples: any[] = [];
  public cities: any[] = [];
  public entryMedicalOffices: any[] = [];
  public entryActions: any[] = [];

  get actTitle() {
    return this.$t("Редактирование акта " + this.form.number);
  }

  get yesNoOptions() {
    return [
      { text: this.$t("Не выбрано"), value: "" },
      { text: this.$t("Да"), value: true },
      { text: this.$t("Нет"), value: false },
    ];
  }

  get entryOptions() {
    return [
      { text: this.$t("Не выбрано"), value: "" },
      { text: this.$t("Акция"), value: 1 },
      { text: this.$t("Мед. учреждения"), value: 2 },
      { text: this.$t("Казань Экспресс"), value: 3 },
      { text: this.$t("Почта России"), value: 5 },
    ];
  }

  public findCity() {
    const self = this;
    jsonp(
      `https://kladr-api.ru/api.php?contentType=city&limit=10&query=${this.form.income_city}`,
      null,
      function (__err, data) {
        self.cities = data.result;
      }
    );
  }

  public entryTypeChanged() {
    this.form.entry_action_id = null;
    this.form.income_city = null;
    this.form.entry_medical_office_id = null;
  }

  public entryOptionsClass(val: any) {
    switch (val) {
      case 1:
        return "outline-warning";
      case 2:
        return "outline-primary";
      case 3:
        return "outline-danger";
      case 4:
        return "outline-warning";
      case 5:
        return "outline-danger";
    }
    return "outline-secondary";
  }

  public submitOnEnter(e: any) {
    const modal = document.querySelector(".modal.show");
    if (
      e.key === "Enter" &&
      e.target.type !== "textarea" &&
      modal == null &&
      !e.target.hasAttribute("aria-selected")
    ) {
      this.save();
      e.preventDefault();
    }
  }

  public created() {
    this.getDictionaries();
  }

  public getDictionaries() {
    axios.get("/pmdd/DictionaryGroup").then((response) => {
      this.biomaterialSamples = response.data.biomaterial_samples;
      this.entryActions = response.data.entry_actions;
      this.entryMedicalOffices = response.data.entry_medical_offices;
    });
  }

  public save() {
    this.submit("/certificates");
  }

  protected mounted() {
    window.addEventListener("keydown", this.submitOnEnter);
  }

  protected beforeDestroy() {
    window.removeEventListener("keydown", this.submitOnEnter);
  }
}
